module.exports = __webpack_public_path__ + "static/media/iphone_11_white.69c664fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_white.png
// module id = 2073
// module chunks = 0